import apiService from '../utils/apiService';
import { monitoringActions } from '../reducers/monitoring';
import { monitoringLastSynchronizationPath } from '../constants/apiEndpoints';
import { errorAction } from '../utils/actions';

export const fetchMonitoringLastSynchronization = (messages) => {
  return (dispatch) => {
    dispatch(monitoringActions.actionStart());
    return apiService
      .get(monitoringLastSynchronizationPath())
      .then((response) => {
        dispatch(monitoringActions.setLastSynchronizationDate(response.data));
      })
      .catch((err) => {
        errorAction(err, monitoringActions.actionError, dispatch, messages);
      });
  };
};

export const clearMonitoringLastSynchronization = () => {
  return (dispatch) => {
    dispatch(monitoringActions.clearLastSynchronizationDate());
  };
};
